// extracted by mini-css-extract-plugin
export default {"image":"Image_image__2w4YP","userHandle":"Image_userHandle__1ECup"};